import { msg } from 'gt-react';
import { Action, Subject } from '@erp/authz';
import { ProductModule } from '@erp/shared-types';
import {
  createRoute,
  lazyRouteComponent,
  redirect,
} from '@tanstack/react-router';
import {
  Route as pathlessAuthenticatedRoute,
  requireModules,
  requirePermission,
} from '../../route';

const ConfigAuthoringPage = lazyRouteComponent(
  () => import('./ConfigAuthoringPage'),
  'ConfigAuthoringPage',
);

export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/ship-and-debit/config-authoring',
  staticData: {
    app: {
      access: {
        modulesAnyOf: [ProductModule.SHIP_AND_DEBIT],
        permissionsAnyOf: [{ action: Action.Read, subject: Subject.SDAdmin }],
      },
    },
  },
  component: ConfigAuthoringPage,
  loader: () => ({
    crumb: msg('Config Authoring', { context: 'page breadcrumb' }),
  }),
  beforeLoad: async ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.SHIP_AND_DEBIT],
    });
    await requirePermission({
      context,
      action: Action.Read,
      subject: Subject.SDAdmin,
    });
    // The parser editor now lives on each supplier's own page, alongside the rest
    // of that supplier's settings. Redirect rather than delete so existing links
    // and bookmarks land somewhere useful.
    throw redirect({ to: '/ship-and-debit/suppliers' });
  },
});
